import { Constants } from "@eagerdog/constants";

import { IOption } from "src/components/Dropdown/Dropdown";

const dogWheelchairOptions : IOption[] = [
  { value: Constants.dog_wheelchair_options.none, id: Constants.dog_wheelchair_options.none },
  { value: Constants.dog_wheelchair_options.manual, id: Constants.dog_wheelchair_options.manual },
  { value: Constants.dog_wheelchair_options.electric, id: Constants.dog_wheelchair_options.electric },
];

export { dogWheelchairOptions }
